import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import api from "./api";
import Modal from "../components/Modal";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

export function AppProvider({ children }) {
  const user = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);
  const [meta, setMeta] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [confirmState, setConfirmState] = useState(null);
  const tid = useRef(0);

  useEffect(() => {
    api.get("/meta").then((r) => setMeta(r.data)).catch(() => setMeta({}));
  }, []);

  const toast = useCallback((message, type = "ok") => {
    const id = ++tid.current;
    setToasts((t) => [...t, { id, message, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3800);
  }, []);

  const confirm = useCallback(
    (message, { okText = "بله، انجام شود", danger = true } = {}) =>
      new Promise((resolve) => setConfirmState({ message, okText, danger, resolve })),
    [],
  );
  const close = (v) => { confirmState.resolve(v); setConfirmState(null); };

  const value = useMemo(() => ({ user, meta, toast, confirm }), [user, meta, toast, confirm]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <div className="toast-box">
        {toasts.map((t) => <div key={t.id} className={`toast ${t.type === "err" ? "err" : ""}`}>{t.message}</div>)}
      </div>
      {confirmState && (
        <Modal title="تأیید" onClose={() => close(false)} small
          footer={
            <>
              <button className={`btn ${confirmState.danger ? "btn-danger" : ""}`} onClick={() => close(true)}>{confirmState.okText}</button>
              <button className="btn btn-ghost" onClick={() => close(false)}>انصراف</button>
            </>
          }>
          <p style={{ paddingBottom: 12, lineHeight: 2 }}>{confirmState.message}</p>
        </Modal>
      )}
    </Ctx.Provider>
  );
}
